import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toast } from '@utima/ui';
import { Suspense } from 'react';

import {
  ErrorPage,
  NotFoundPage,
  SurfaceBackground,
  SurfaceBackgroundPolygons,
} from '@/components';
import { AppSettings } from '@/constants';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: ErrorPage,
  notFoundComponent: NotFoundPage,
});

export function RootLayout() {
  return (
    <>
      <div className='text-foreground font-sans'>
        <Outlet />
        <Toast expand closeButton position='top-right' />
        {AppSettings.debug && (
          <>
            <Suspense fallback={null}>
              <div className='ml-16'>
                <TanStackRouterDevtools position='bottom-right' />
              </div>
            </Suspense>
            <Suspense fallback={null}>
              <ReactQueryDevtools buttonPosition='bottom-right' />
            </Suspense>
          </>
        )}
      </div>

      <SurfaceBackground />
      <SurfaceBackgroundPolygons />
    </>
  );
}
